import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  color,
  space,
  typography,
  shadow,
  layout,
  compose,
  variant,
  system,
} from 'styled-system'

import { variants } from './textVariants'

const style = system({
  textTransform: true,
  cursor: true,
  flex: true,
})

const styleText = compose(
  typography,
  color,
  space,
  typography,
  layout,
  shadow,
  style,
)

const variantsSelect = {
  default: {},
  active: {
    textDecoration: 'underline',
    color: 'text.activeText',
  },
}

const styledSystemProps = new Set([
  ...typography.propNames,
  ...color.propNames,
  ...space.propNames,
  ...typography.propNames,
  ...layout.propNames,
  ...shadow.propNames,
  ...style.propNames,
])

const customProps = [
  'nowrap',
  'preLine',
  'textTransform',
  'textOverflow',
  'variant',
]
const propsToFilter = new Set([...styledSystemProps, ...customProps])

const Text = styled.p
  .withConfig({
    shouldForwardProp: (prop) => !propsToFilter.has(prop),
  })
  .attrs(({ variant = 'body14n' }) => ({
    variant,
  }))(
  ({ nowrap, preLine, link, ellipsis }) => ({
    ...(preLine && { whiteSpace: 'pre-line' }),
    ...(nowrap && { whiteSpace: 'nowrap' }),
    ...(ellipsis && {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    ...(link && {
      cursor: 'pointer',
      '&:hover': { textDecoration: 'underline' },
    }),
  }),
  {
    padding: 0,
    margin: 0,
  },
  variant({
    variants,
  }),
  variant({
    variants: variantsSelect,
    prop: 'active',
  }),
  styleText,
)

const variantProps = Object.keys(variants)
const variantPropTypes = PropTypes.oneOf(variantProps)

Text.propTypes = {
  as: PropTypes.node,
  sx: PropTypes.object,
  variant: PropTypes.oneOfType([
    variantPropTypes,
    PropTypes.arrayOf(variantPropTypes),
  ]),
}

Text.displayName = 'Text'

export default Text
